// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"e09039f5","703":"b0ea45a5","787":"20da39d4"}[chunkId] + ".chunk.js";
};